import { AlertCircle } from 'lucide-react';

import { cn } from '@/utils/cn';

/**
 * A field error, announced rather than only shown.
 *
 * `role="alert"` because a validation message that appears silently is invisible to
 * a screen reader user who has already moved on to the next field. The icon is there
 * because colour alone must never carry the message.
 */
export const FormFieldError = ({
  id,
  message,
  className,
}: {
  id?: string;
  message?: string;
  className?: string;
}) => {
  if (!message) return null;

  return (
    <p
      id={id}
      role="alert"
      className={cn('flex items-start gap-1.5 text-caption text-danger-fg', className)}
    >
      <AlertCircle aria-hidden className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>{message}</span>
    </p>
  );
};
